import React, { Component } from "react";
import { formatoSeparadorMilesValue, formatoSeparadorMilesReturn, separadorPuntoMiles, splitImporte } from '../../../generico/utils/FormatoInput';
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import PrestamoInmediatoService from "../../../../services/solicitudes/PrestamoInmediatoService";
import PrestamoPreaprobadoService from '../../../../services/solicitudes/PrestamoPreaprobadoService';
import Authservice from "../../../../services/login/auth.service";
import CuentaDeposito from "../../../generico/CuentaDeposito";

// eslint-disable-next-line react-hooks/rules-of-hooks
var prestamo = {
  minMonto: 500000,
  maxMonto: sessionStorage.getItem("saldoLineaPi"),
  monto: undefined,
  plazo: undefined,
  sucursal: undefined,
  interes: undefined

};
var datosMora = {
  "depositoAporte": "",
  "moraAporte": "L",
  "moraSolidaridad": "",
  "moraAporteConyuge": "",
  "moraSolidaridadConyuge": ""
};
var montoCuota = {
  montoIngresado: undefined,
  sucursalId: undefined,
};



export default class Paso1 extends Component {

  timeout = null;

  TIPO_DEBITO = "D";
  TIPO_CREDITO = "C";
  constructor(props) {
    super(props);
    this.state = {
      monto: "500.000",
      value: 500000,
      plazo: this.props.plazo ? this.props.plazo : '48',
      sucursalDesembolso: undefined,
      sucursalDesembolsoLabel: undefined,
      montoLimInf: 500000,
      limiteSuperior: props.limiteSuperior,
      sucursalList: [],
      plazosList: [],
      itemsConfirm: [],
      itemsMoraCompromiso: [],
      moraCompromisoTotal: 0,
      totalDesembolso: 0,
      VmontoCuota: 5000000,
      mostrarMontoCota: false,
      selectPlazoValue: { label: "", value: "" },

      range: '50000000',
      rangePlazo: '6',
      interes: '',
      seleccionado: false,
      listaPlazos: [],
      mostrarSelectorCuenta: false,
      mostrarUnaCuenta: false,


    };
    this.getCuentasOrigen = this.getCuentas.bind(this);
    this.state = this.getInitialState();


  }

  getInitialState = () => ({
    listaPrestamo: [],
    prestamoSelected: [],
    disabledNext: true,
    cuentaDeposito: null,
    importe: this.props.importe,
    cantCuotas: null,
    montoCuota: null,
    cuota: null,
    disableSgte: false,
    montoLimInf: 500000,
    limiteSuperior: formatoSeparadorMilesValue(sessionStorage.getItem("saldoLineaPi")),
    VmontoCuota: 500000,
    range: '50000000',
    rangePlazo: '6',
    seleccionado: this.props.plazo ? this.props.plazo : '48',
    plazo: this.props.plazo ? this.props.plazo : '48',
    interes: "",
    seleccionado12: false,
    seleccionado24: false,
    seleccionado36: false,
    seleccionado48: false,

    listaPlazos: this.props.listaPlazos,
    cuentasOrigen: [],
    mostrarSelectorCuenta: false,
    mostrarUnaCuenta: false,
    cuentaDebito: null,
    prestamo: {
      minMonto: 500000,
      maxMonto: sessionStorage.getItem("saldoLineaPi"),
      monto: undefined,
      plazo: this.props.plazo ? this.props.plazo : '48',
      sucursal: undefined,
      interes: undefined

    }
  })

  componentDidMount() {
    /*  setTimeout(() => {
        this.setState({seleccionado:this.props.plazo});
      }, 100);*/
    prestamo.plazo = this.props.plazo ? this.props.plazo : '48';
    prestamo.monto = this.state.montoLimInf;
    montoCuota.montoIngresado = this.state.limiteSuperior;
    montoCuota.plazo = this.props.plazo ? this.props.plazo : '48';

    this.getCuentas(this.TIPO_DEBITO);

    //this.setState({listaPlazos:this.state.listaPlazos.reverse()});

    //this.btnHabilitar.disabled = true;


    this.obtenerMontoCuota();

  }
  obtenerMoraCompromiso(monto, idModalidad, moneda) {
    trackPromise(
      PrestamoPreaprobadoService.getMoraCompromisoPi(monto, idModalidad, moneda)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno === "0") {

            //// posee deuda de aporte
            var sumDeuda = jsonData.datos.depositarAporte + jsonData.datos.moraSolidaridad + jsonData.datos.moraAporteConyuge + jsonData.datos.moraSolidaridadConyuge
            if (sumDeuda > 0) {
              var totalDesembolso = this.state.value - sumDeuda

              var _itemsMoraCompromiso = [
                { concepto: "Mora Aporte / Relación Aporte", valor: formatoSeparadorMilesValue(jsonData.datos.depositarAporte) + " Gs. " },
                { concepto: "Mora Solidaridad", valor: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridad) + " Gs. " },
                { concepto: "Mora Aporte del Cónyuge", valor: formatoSeparadorMilesValue(jsonData.datos.moraAporteConyuge) + " Gs. " },
                { concepto: "Mora Solidaridad del Cónyuge", valor: formatoSeparadorMilesValue(jsonData.datos.moraSolidaridadConyuge) + " Gs. " },
              ];

              datosMora.depositoAporte = formatoSeparadorMilesValue(jsonData.datos.depositarAporte) + " Gs. ";
              datosMora.moraAporte = formatoSeparadorMilesValue(jsonData.datos.moraSolidaridad) + " Gs. ";
              datosMora.moraSolidaridad = formatoSeparadorMilesValue(jsonData.datos.moraAporteConyuge) + " Gs. ";
              datosMora.moraAporteConyuge = formatoSeparadorMilesValue(jsonData.datos.moraSolidaridadConyuge) + " Gs. ";



              this.setState({
                itemsMoraCompromiso: _itemsMoraCompromiso,
                moraCompromisoTotal: sumDeuda,
                totalDesembolso: totalDesembolso
              });
            }

            var sucursalSelect = this.state.sucursalList.find(x => x.value === this.state.sucursalDesembolso)
            this.state.sucursalDesembolsoLabel = sucursalSelect.label;
            var montoSolicitado = Number(this.state.value).toString();
            var _itemsConfirm = [
              { concepto: "Sucursal del Desembolso", valor: sucursalSelect.label },
              { concepto: "Plazo (meses)", valor: this.state.plazo },
              { concepto: "Monto de Crédito", valor: formatoSeparadorMilesValue(montoSolicitado) + " Gs." },
            ];
            this.setState({ itemsConfirm: _itemsConfirm });
            ///// levanta popup de confirmación de crédito
            this.modalCtrlConfirm.click();
          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }

        ));
  }


  //cuando se modifica monto con componente de rango
  handleVolumeChange = (event) => {

    var numero = event.target.value
    var importe = splitImporte(numero);
    prestamo.monto = importe;

    montoCuota.montoIngresado = importe;
    montoCuota.montoIngresado = importe;


    var _monto = formatoSeparadorMilesValue(event.target.value);
    this.setState({ importe: _monto, cuotas: 8, range: importe });
    /*console.log("Porcentaje ", event.target.value);
    console.log("Importe ", this.state.importe);
    console.log("cantidad cuota 3 ", this.state.cuotas);*/
    this.setState({ mostrarMontoCota: false });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      console.log("Ejecutar llamado");
      this.obtenerMontoCuota();
    }, 800)

  };

  //cambia valor de monto en el input
// cambia valor de monto en el input
onChangeValue = (e) => {
  var numero = e.target.value;
  var importe = splitImporte(numero);

  // 🔹 límite máximo
  const LIMITE = Number(this.state.limiteSuperior) || 0;;
  if (importe > LIMITE) {
    importe = LIMITE;
    numero = LIMITE.toString();
  }

  prestamo.monto = importe;
  montoCuota.montoIngresado = importe;

  this.setState({ value: importe, monto: importe });
  this.setState({ importe: numero, range: splitImporte(numero) });

  var _monto = importe;
  if (importe !== "") {
    _monto = formatoSeparadorMilesValue(importe);
  }

  this.setState({ importe: _monto });

  if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
    _monto = _monto.substr(1);
  }
  this.setState({ VmontoCuota: _monto });

  this.habilitarBoton();
  this.obtenerMontoCuota();
};


  //cuando se modifica plazo con componente de rango
  handleVolumeChangePlazo = (event) => {

    // var numero = event.target.value
    // var importe = splitImporte(numero);
    //montoCuota.montoIngresado = importe;

    console.log(event.target.value);
    // var importe= (Math.round(50000000 * (event.target.value +20))/100);

    /* if (event.target.value > 20) {
       this.setState({ importe: (50000000 * (event.target.value)) / 100, cuotas: 8 });
     }*/

    let valor = this.state.plazosList.filter(plazo => plazo.value === event.target.value);
    this.setState({ plazo: event.target.value, selectPlazoValue: valor, rangePlazo: event.target.value });
    prestamo.plazo = event.target.value;
    montoCuota.plazo = event.target.value;
    this.obtenerMontoCuota();
  };



  handleCambiarCantCuota = (event) => {
    console.log("cantidad cuotaa ", this.state.cantCuotas);
    console.log("cantidad cuota 3 ", this.state.cantCuotas);
    console.log("cantidad cuota 1", this.cantCuotas);
    this.controlarCampos();

  }

  handleCambiarImporte = (event) => {
    this.setState({
      importe: event.target.value
    });

    console.log("importe cuota ", event.target.value);
    this.importe = event.target.value;
    console.log("importe cuota 1", this.state.importe);
    this.controlarCampos();
  }


  handleCambiarMontoCuota = (event) => {

    var _monto = formatoSeparadorMilesReturn(event);
    if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
      _monto = _monto.substr(1);
    }
    this.setState({
      montoCuota: _monto,
    });
    //  _monto = splitImporte(_monto);
    // this.enableNext(parseFloat(_monto), this.state.motivo, this.state.otrosDesc);


    /* this.setState({
       montoCuota: event.target.value
     });*/
    console.log("monto cuota ", event.target.value);
    this.montoCuota = event.target.value;
    console.log("monto cuota 1", this.state.montoCuota);
    this.controlarCampos();
  }

  getCuentas(tipo) {
    trackPromise(
      PrestamoInmediatoService.getCuentas(tipo).then((response) => {
        this.setState({ mostrarSelectorCuenta: false, mostrarUnaCuenta: false });
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        this.setState({ cuentasOrigen: jsonData.datos });
        this.habilitarBoton();

        if (jsonData.datos.length === 1) {
          var cuentaD = jsonData.datos[0].ahorro + " " + jsonData.datos[0].descripcion + " " + jsonData.datos[0].saldoTotal + " " + jsonData.datos[0].moneda
          this.setState({ mostrarSelectorCuenta: false, mostrarUnaCuenta: true, cuentaDeposito: cuentaD , cuentaDebito : jsonData.datos[0].ahorro });
        } if (jsonData.datos.length > 1) {
          this.setState({ mostrarSelectorCuenta: true, mostrarUnaCuenta: false, cuentaDeposito: cuentaD });

        }

      })
    );
  }



  componentDidUpdate(prevProps, prevState) {

  }


  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  enableNext() {
    this.checkGrilla();
  }



  paso1Next = () => {

    this.refPaso2.current.getDetalles(this.state.rptPaso1);
    this.refPaso1.current.nextStep.click();

  };

  loadDatosSocio = () => {
    if (this.state.optionsCuentas !== undefined)
      return this.state.optionsCuentas
    else {
      return this.getCuentasSocio()
    }
  }


  //calculta monto cuota en base a monto y plazo
  obtenerMontoCuota = async () => {
    /// this.mostrarMontoCota = false;
    montoCuota.montoIngresado = splitImporte(montoCuota.montoIngresado);
    this.setState({ limiteSuperior: splitImporte(this.state.limiteSuperior) });
    this.setState({ mostrarMontoCota: false });
    if (Number(montoCuota.montoIngresado) >= Number(prestamo.minMonto) &&
      Number(montoCuota.montoIngresado) <= Number(prestamo.maxMonto)) {

      await trackPromise(
        PrestamoInmediatoService.getMontoCuota(montoCuota.montoIngresado, montoCuota.plazo)
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            if (jsonData.codigoRetorno === "0") {

              this.setState({ VmontoCuota: jsonData.datos.montoCuota, interes: jsonData.datos.tasaInteres });
              this.setState({ mostrarMontoCota: true });
              //$("#montoCuota").text(formatoSeparadorMilesValue(jsonData.datos.montoCuota));
              //$("#tasaInteres").text(jsonData.datos.tasaInteres);
              this.habilitarBoton();
            }
            else {
              Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
              return;
            }
          }

          ));

    } else {
      /* var mensaje = "Monto no esta dentro del rango";
       Popup.queue(this.notifiPopup("Monto incorrecto", mensaje));
       return;*/
    }
  }

  habilitarBoton() {
    if (prestamo.monto !== undefined && prestamo.monto >= 500000) {



      if (this.state.cuentasOrigen.length === 1) {
        this.setState({ disableSgte: false });
      } else if (this.state.cuentasOrigen.length > 1) {
        if (this.state.cuentaDeposito) {
          this.setState({ disableSgte: false });
        } else {
          this.setState({ disableSgte: true });
        }
      } else {
        this.setState({ disableSgte: false });
      }



    } else {
      //this.btnHabilitar.disabled = true;
      this.setState({ disableSgte: true });
    }
  }



  controlarCampos = () => {
    this.setState({ disableSgte: true });
    console.log("cuota controlar ", this.state.cantCuotas);
    console.log("cuota controlar ", this.state.importe);
    console.log("cuota controlar ", this.state.montoCuota);

    if (this.state.cuentaDeposito !== undefined && this.state.importe !== null && this.state.importe !== ''
      && this.state.cantCuotas != null && this.state.cantCuotas !== '' && this.state.montoCuota != null && this.state.montoCuota !== '') {

      this.setState({ disableSgte: false });

    }

  }
  //se obtiene listado de plazos
  obtenerplazo() {
    trackPromise(
      PrestamoPreaprobadoService.getPlazosPi()
        .then((response) => {
          var data = JSON.stringify(response.data);

          var jsonData = JSON.parse(data);
          if (jsonData.codigoRetorno === "0") {
            setTimeout(() => {
              this.setState({ listaPlazos: jsonData.datos, plazo: jsonData.datos[jsonData.datos.length - 1] });
              prestamo.plazo = jsonData.datos[jsonData.datos.length - 1];
            }, 300);

            this.habilitarBoton();

          }
          else {
            Popup.queue(this.notifiPopup("Error", jsonData.mensajeRetorno));
            return;
          }
        }

        ));
  }

  //al cambiar plazo
  handleChangeSelectorPlazo = (selectedOption) => {
    if (selectedOption === null) {
      this.setState({ plazo: undefined });
    }
    else {
      this.setState({ plazo: selectedOption.value, selectPlazoValue: selectedOption, rangePlazo: splitImporte(selectedOption.value) });

      prestamo.plazo = selectedOption.value;
      montoCuota.plazo = selectedOption.value;

      //  this.habilitarBoton();
      this.obtenerMontoCuota();
    }
  };

  handleChange(event) {

    this.setState({ value: event.target.value });
  }


  cambiarColor(event) {
    if (this.state.seleccionado === event.target.value) {
      this.setState({ seleccionado: event.target.value });
    } else {
      this.setState({ seleccionado: event.target.value });
      this.setState({ plazo: event.target.value });
      prestamo.plazo = event.target.value;
      montoCuota.plazo = event.target.value;
      this.obtenerMontoCuota();
    }


  }

  selectorValue = (dataFromChild, item) => {

    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.ahorro,
        detalleCuenta: dataFromChild.ahorro + " - " + Authservice.getSocio().nombreCompleto.trim(),
        itemSelected: item,
        cuentaDeposito: item.label
      },
      this.habilitarBoton
    );

  };
  montoValue = (_monto) => {
    this.setState(
      {
        monto: _monto,
      },
      this.checkGrilla
    );
  };



  render() {


    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Préstamo
                    </span>
                  </div>
                </span>
              </li>

              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Liquidación de Préstamo
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row  justify-content-center">

          <div className="col-sm-8 col-md-8 col-lg-7 ">
            <label>

            </label>

            <div className="form-group">
              <div class="col-lg-12 p-0">


                <label className="input-label-bold">Elegí el importe *</label>
              </div>
              <input name="documentoNew" value={this.state.importe} onChange={this.onChangeValue} type="text"
                className="input-box form-control"
               /* onChange={(val) => {
                  this.setState({ importe: val.target.value });
                }} *//>
              <div class="row form-group form-group-1">

                <div class="col-lg-12 content-range">
                  <input class="col-lg-12" id="myRange" type="range" min="500000" max={this.state.limiteSuperior} step="100000" value={this.state.range} defaultValue={this.state.range}
                    onChange={(val) => { this.handleVolumeChange(val) }} />
                </div>
                <div class="row col-lg-12">
                  <div class="col-lg-5 ">
                    <label className="input-label presMin">Importe máximo: 500.000 Gs.</label>
                  </div>
                  <div class="col-lg-2">
                    <label className="input-label"></label>
                  </div>
                  <div class="col-lg-5 montoMaxRange">
                    <label className="input-label presMax">Importe máximo: {separadorPuntoMiles(this.state.limiteSuperior)} Gs.</label>
                  </div>
                </div>
              </div>

            </div>
            <div className="">

              <div class="row ">

              </div>
              <div className="col-md-8 p-0">
                <div className="form-group">

                  <label className="input-label-bold pb-2">Elegí la cantidad de cuotas *</label>

                  <div class="col-lg-12 p-0 row">
                    {this.props.listaPlazos.map(elemento =>
                      <div class="col-lg-3">


                        <button onClick={(val) => { this.cambiarColor(val) }} value={elemento}


                          className={`btn btn-cu-plazo boton-plazo  ${(this.state.seleccionado === elemento) ? 'btnPlazo' : 'btnPlazo1'}`}>{elemento}</button>

                      </div>
                    )}

                  </div>

                  <div id="plazo-error" className="error"
                    style={{ width: "100%", marginTop: ".25rem", fontSize: "80%", color: "#dc3545", display: "none" }}>
                    Este campo es requerido
                  </div>
                </div>
              </div>

              <br />
              {this.state.cuentasOrigen.length > 1 &&

                <CuentaDeposito
                  renderMonto="true"
                  selectorValue={this.selectorValue.bind(this)}
                  montoValue={this.montoValue.bind(this)}
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  monto={this.state.monto}
                  itemSelected={this.state.itemSelected}
                  ngChange={this.habilitarBoton}
                />
              }

              {this.state.cuentasOrigen.length === 1 &&
                <div class="col-lg-12 p-0">
                  <label className="input-label-bold pb-1 ">Cuenta a acreditar el Préstamo *</label>
                  <input name="documentoNew" disabled value={this.state.cuentaDeposito} onChange={this.onChangeValue} type="text"
                    className="input-box form-control"
                /* onChange={(val) => {
                this.setState({ importe: val.target.value });
                }} *//>
                </div>
              }
            </div>
            <br /> <br />
            <div className="row float-right" >
              <div className="col-md-12">
                {this.state.mostrarMontoCota &&
                  (
                    <div className="form-group" >
                      <label className="input-label-bold limite-minimo-label-pi" >
                        Monto de Cuota : <span id="montoCuota"> {separadorPuntoMiles(this.state.VmontoCuota)}  Gs.</span><br />
                        {/* Tasa de Interés : <span id="tasaInteres"></span>% */}
                      </label>
                    </div>
                  )}
              </div>
            </div>

          </div>

        </div>
        <br />

        <br />

        {this.state.datosOficialCuenta &&
          <div className="col-12 my-1">
            <div className="row p-2 text-dark agendar-box">
              <div className="col-12">
                <h6>Oficial de Cuentas</h6>
              </div>
              <div className="col-sm-12 col-md-8 col-lg-7 justify-content-center">
                <p className="m-0 text-left oficial"><span><b>Nombre:</b> </span>{this.state.datosOficialCuenta.nombreCompleto}</p>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-5 justify-content-center">
                <p className="m-0 text-left oficial"><span><b>Teléfono: </b></span> {this.state.datosOficialCuenta.celular}</p>
              </div>
              <div className="col-sm-12 col-md-8 col-lg-7 justify-content-center">
                <p className="m-0 text-left oficial"><span><b>E-mail: </b></span> {this.state.datosOficialCuenta.email}</p>
              </div>
              <div className="col-sm-12 col-md-4 col-lg-5 justify-content-center">
                <p className="m-0 text-left oficial"><span><b>Sucursal: </b></span> {this.state.datosOficialCuenta.sucursal}</p>
              </div>
            </div>
          </div>
        }

        <hr />
        <div className="row">
          <div className="col-lg-10 col-md-9">
            <label
              className="input-label-bold-obligatorio float-left">
              (*) Campos Obligatorios
              <br />
            </label>
          </div>
          <div className="col-lg-2 col-md-3">
            <button

              id="btn-next-paso"
              className="btn btn-cu-primary"

              disabled={this.state.disableSgte}
              // disabled={this.disableSgte}
              onClick={() => {

                this.props.returnPaso1(this.state.importe, this.state.plazo, this.state.VmontoCuota, this.state.interes, this.state.cuentaDeposito, datosMora, this.state.cuentaDebito, this.state.limiteSuperior);
                this.nextStep.click();
              }}>

              Continuar <FontAwesomeIcon icon={faArrowRight} />
            </button>
            <button
              hidden
              ref={(a) => (this.nextStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.nextStep}
            ></button>
          </div>
        </div>
      </div>
    );
  }
}